import React, { useMemo } from 'react'
import { Card, CardHeader, Box, Typography } from '@mui/material'
import ReactApexChart from 'react-apexcharts'
import PropTypes from 'prop-types'
import './UsageChart.css'
import moment from 'moment'

SignUpUserChart.propTypes = {
  duration: PropTypes.string,
  chartData: PropTypes.array,
}

export default function SignUpUserChart ({ duration, chartData }) {
  const safeData = useMemo(() => {
    if (!Array.isArray(chartData)) return []
    return chartData.map(i =>
      typeof i?.signUpUserCount === 'number' && !Number.isNaN(i.signUpUserCount)
        ? i.signUpUserCount
        : Number(i?.signUpUserCount) || 0
    )
  }, [chartData])

  const totalUsers = useMemo(() => {
    return safeData.reduce((acc, curr) => acc + curr, 0)
  }, [safeData])

  const seriesData = useMemo(() => {
    return [
      {
        name: 'New Users',
        data: safeData,
      },
    ]
  }, [safeData])

  const chartLabels = useMemo(() => {
    if (!Array.isArray(chartData)) return []
    return chartData.map(i => {
      const date = new Date(i?.date?.split('T')?.[0])
      if (duration === 'monthly') {
        return moment(date).format('DD/MM')
      }
      if (duration === 'yearly') {
        if (i?.month) {
          return `${i?.month?.split(' ')[0].slice(0, 3)} ${i?.month?.split(' ')[1] || ''}`.trim()
        }
        return moment(date).format('MMM YYYY')
      }
      if (duration === 'threeMonth') {
        if (i?.weekLabel) {
          return i.weekLabel.split(', ')[0]
        }
        if (i?.weekStart) {
          return moment(new Date(i.weekStart)).format('DD/MM')
        }
        return moment(date).format('DD/MM')
      }
      return moment(date).format('DD/MM/YYYY')
    })
  }, [chartData, duration])

  const chartOptions = useMemo(() => {
    return {
      chart: {
        type: 'line',
        height: '500',
        zoom: {
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: 'straight',
      },
      colors: ['rgb(255, 193, 7)'],
      xaxis: {
        labels: {
          rotate: -45,
          rotateAlways: false,
          trim: true,
          maxHeight: 80,
          style: {
            fontSize: '11px',
          },
        },
      },
      labels: chartLabels,
      dataLabels: {
        enabled: false,
      },
    }
  }, [chartLabels])

  const hasData = Array.isArray(chartData) && chartData.length > 0

  return (
    <Card sx={{ height: { xs: '500px', md: '480px' } }}>
      <CardHeader title={`New Users (${totalUsers})`} />
      {!hasData ? (
        <Box
          sx={{
            height: '360px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography color='text.secondary'>No data available</Typography>
        </Box>
      ) : (
        <ReactApexChart options={chartOptions} series={seriesData} type='line' height={380} />
      )}
    </Card>
  )
}